<template>
    <ul class="socialListWrapper">
        <li v-for="social in activeSocials"
            :key="social.slug"
            :class="['socialList', 'socialList--' + social.slug]">
            <a class="socialList__link" :href="social.url" :title="social.name" target="_blank" rel="noopener">
                <img v-if="social.iconImg"
                     class="socialList__img"
                     :src="social.iconImg"
                     :alt="social.name">
                <component v-else v-bind:is="socialIconComponent(social)"></component>
            </a>
        </li>
    </ul>
</template>

<script>
    import {mapState} from 'vuex'
    import {capitalize} from '../utils/shared';

    export default {
        computed: {
            ...mapState({
                socials: state => state.socials.list,
            }),
            activeSocials() {
                const socials = this.socials || []
                const localIcons = {
                    instagram: '/images/instagram_icon.png',
                    linkedin: '/images/linkedin_icon.png',
                    'little-black-book': '/images/little_black_book_icon.png',
                }
                const fallbackSocials = [
                    {
                        name: 'Instagram',
                        slug: 'instagram',
                        url: 'https://www.instagram.com/roosterpost/',
                        iconImg: localIcons.instagram,
                    },
                    {
                        name: 'LinkedIn',
                        slug: 'linkedin',
                        url: 'https://www.linkedin.com/company/rooster-post-production',
                        iconImg: localIcons.linkedin,
                    },
                    {
                        name: 'Little Black Book',
                        slug: 'little-black-book',
                        url: 'https://lbbonline.com/companies/rooster/',
                        iconImg: localIcons['little-black-book'],
                    }
                ]

                return fallbackSocials.reduce((items, fallbackSocial) => {
                    const exists = items.some((social) => social.slug === fallbackSocial.slug)

                    return exists
                        ? items
                        : items.concat([fallbackSocial])
                }, socials.map((social) => {
                    return localIcons[social.slug]
                        ? Object.assign({}, social, {iconImg: localIcons[social.slug]})
                        : social
                }))
            }
        },
        methods: {
            socialIconComponent: function (social) {
                return capitalize(social.slug) + 'Icon'
            }
        }
    }
</script>

<style scoped>
    .socialList__img {
        display: block;
        width: auto;
        height: auto;
        max-width: 24px;
        max-height: 24px;
        object-fit: contain;
        transition: opacity 0.3s ease 0s;
    }

    .socialList--little-black-book .socialList__img {
        width: 44px;
        height: 28px;
        max-width: none;
        max-height: none;
    }

    .socialList__link:hover .socialList__img {
        opacity: 0.72;
    }
</style>
